import classNames from 'classnames'

import styles from './ContentBlock.module.scss'

export const ContentBlock = ({
  children,
  row,
  column,
  className = '',
  alignStart,
  alignCenter = true,
  alignEnd,
  justifyStart,
  justifyCenter = true,
  justifyEnd,
  stretch = false,
  flex = true,
  padding,
  margin,
  id,
  title = '',
  ...props
}: {
  children: React.ReactNode
  className?: string
  row?: boolean
  column?: boolean
  alignStart?: boolean
  alignCenter?: boolean
  alignEnd?: boolean
  justifyStart?: boolean
  justifyCenter?: boolean
  justifyEnd?: boolean
  flex?: boolean
  padding?: number
  margin?: number
  stretch?: boolean
  id?: string
  style?: React.CSSProperties
  title?: string
  onClick?: () => void
}) => {
  return (
    <div
      className={classNames(styles.contentBlock, {
        [styles.row]: row,
        [styles.column]: column,
        [styles.alignStart]: alignStart,
        [styles.alignCenter]: alignCenter && !alignStart && !alignEnd,
        [styles.alignEnd]: alignEnd,
        [styles.justifyStart]: justifyStart,
        [styles.justifyCenter]: justifyCenter && !justifyStart && !justifyEnd,
        [styles.justifyEnd]: justifyEnd,
        [styles.flex]: flex,
        [styles.stretch]: stretch,
        [className || '']: className,
      })}
      style={{ padding, margin, ...props.style }}
      {...props}
      id={id}
      title={title}
      data-testid="auto-id-e4d8fb1c-2864-4b49-904d-60506459884b">
      {children}
    </div>
  );
}
